import { FC, ReactNode } from 'react';
import {
  DisplayCardContainer,
  DisplayCardHeader,
  DisplayCardSubTitle,
  DisplayCardTitle,
  StyledDisplayCard,
  DisplayCardContent,
  DisplayCardFooter,
  DisplayCardBadge,
} from './DisplayCard.styles';

export type DisplayCardImagePosition = 'left' | 'right';

export interface DisplayCardProps {
  flat?: boolean;
  compact?: boolean;
  icon?: ReactNode;
  title?: string;
  subTitle?: string;
  imageElement?: ReactNode;
  badge?: ReactNode;
  imagePosition?: DisplayCardImagePosition;
  footerElements?: ReactNode;
  className?: string;
  link?: string;
  onClick?: <T>(props: T) => void;
}

export const DisplayCard: FC<DisplayCardProps> = ({
  compact,
  flat,
  icon,
  title,
  subTitle,
  imageElement,
  footerElements,
  badge,
  imagePosition,
  className,
  children,
  onClick,
  link,
  ...restProps
}) => {
  const displayCardHeader = (icon || title || subTitle || badge) && (
    <>
      {badge && <DisplayCardBadge>{badge}</DisplayCardBadge>}
      <DisplayCardHeader>
        {icon && icon}
        {title && (
          <DisplayCardTitle h4 small>
            {title}
          </DisplayCardTitle>
        )}
        {subTitle && <DisplayCardSubTitle>{subTitle}</DisplayCardSubTitle>}
      </DisplayCardHeader>
    </>
  );

  return (
    <StyledDisplayCard
      imagePosition={imagePosition}
      flat={flat}
      className={className}
      link={link}
      {...(link ? { as: 'a', href: link } : { as: 'div', onClick })}
      {...restProps}
    >
      {imageElement}
      <DisplayCardContainer compact={compact}>
        {displayCardHeader}
        <DisplayCardContent>{children}</DisplayCardContent>
        {footerElements && <DisplayCardFooter>{footerElements}</DisplayCardFooter>}
      </DisplayCardContainer>
    </StyledDisplayCard>
  );
};
